(function () {
  'use strict';

  var STORAGE_KEY = 'ccMemberAccess:v1';
  var gates = Array.from(document.querySelectorAll('[data-cc-member-gate]'));
  var protectedAreas = Array.from(document.querySelectorAll('[data-cc-member-content]'));

  if (!gates.length || !protectedAreas.length) return;

  function readAccess() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) || '';
    } catch (error) {
      return '';
    }
  }

  function writeAccess(value) {
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
      return true;
    } catch (error) {
      return false;
    }
  }

  function clearAccess() {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      return;
    }
  }

  function expectedHash() {
    return gates[0].dataset.accessHash || '';
  }

  function setUnlocked(unlocked) {
    document.documentElement.classList.toggle('cc-member-unlocked', unlocked);
    gates.forEach(function (gate) { gate.hidden = unlocked; });
    protectedAreas.forEach(function (area) { area.hidden = !unlocked; });
  }

  async function hashPassword(value) {
    var bytes = new TextEncoder().encode(value.trim());
    var digest = await window.crypto.subtle.digest('SHA-256', bytes);
    return Array.from(new Uint8Array(digest)).map(function (byte) {
      return byte.toString(16).padStart(2, '0');
    }).join('');
  }

  setUnlocked(readAccess() === expectedHash());

  gates.forEach(function (gate) {
    var form = gate.querySelector('[data-cc-password-form]');
    var input = form.querySelector('input[name="memberPassword"]');
    var error = form.querySelector('[data-cc-password-error]');
    var showPassword = form.querySelector('[data-cc-show-password]');

    showPassword.addEventListener('change', function () {
      input.type = showPassword.checked ? 'text' : 'password';
    });

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      error.textContent = '';

      if (!input.value.trim()) {
        error.textContent = 'Enter the current member password.';
        input.focus();
        return;
      }

      if (!window.crypto || !window.crypto.subtle) {
        error.textContent = 'This browser cannot verify the password. Update the browser and try again.';
        return;
      }

      var submittedHash = await hashPassword(input.value);
      if (submittedHash !== expectedHash()) {
        error.textContent = 'That password is not correct.';
        input.select();
        return;
      }

      writeAccess(submittedHash);
      input.value = '';
      setUnlocked(true);
      window.scrollTo({ top: 0, behavior: 'auto' });
    });
  });

  document.querySelectorAll('[data-cc-lock-access]').forEach(function (button) {
    button.addEventListener('click', function () {
      clearAccess();
      setUnlocked(false);
      window.scrollTo({ top: 0, behavior: 'auto' });
    });
  });
})();
